import React, { useState, useContext, useRef } from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@PetSureAustralia/petsure-react-ui-library/distLib/components';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useReactToPrint } from 'react-to-print';
import { CSPUrlsMap } from '../../../routes/CSPUrlsMap';
import { PetDetailsPropTypes } from '../../../propTypes/petDetails';
import { WhatsCoveredPopup } from '../WhatsCoveredPopup/WhatsCoveredPopup';
import './petPolicyLinksBar.scss';
import { NewClaimButton } from '../../claims/newClaim/newClaimButton/newClaimButton';
import { FeatureFlagContext } from '../../../contextProviders/featureFlagContext';
import { setFullPolicyNumber } from '../../../store/slice/petDetailsSlice';
import { getGtmService } from '../../../services/gtmService/GtmService';
import { BrandContext } from '../../../contextProviders/brandContext';
import { useGetCmsTagsQuery } from '../../../data/kontentAi';
import { legacyPolicyNumberHandler } from '../../../helpers/paymentHelper';

export const PetPolicyLinksBar = ({ petDetail }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const { FullPolicyNumber, PolicyDetails } = petDetail;
  const { cspConfiguration } = useContext(FeatureFlagContext);
  const { activeBrandContext } = useContext(BrandContext);
  const isWhatsCoveredEnabled = cspConfiguration?.IsWhatsCoveredEnabled || false;
  const isPayNowEnabled = cspConfiguration?.IsPayNowEnabled;

  const isKontentAiPreviewEnabled = cspConfiguration?.IsKontentAIPreviewEnabled || false;
  const { data: cmsTags } = useGetCmsTagsQuery({
    brandPartner: activeBrandContext.brand.key,
    previewEnabled: isKontentAiPreviewEnabled
  });

  const showWhatsCovered = () => {
    setIsOpen(true);

    const gtm = getGtmService();
    gtm.pushWhatsCovered(FullPolicyNumber);
  };

  const displayTags = {
    benefitPercentage: PolicyDetails?.BenefitPercentage,
    excesstype: PolicyDetails?.ExcessType,
    excess: PolicyDetails?.Excess,
    policyName: PolicyDetails?.PolicyName,
    animalName: petDetail?.Name,
    productGeneration: PolicyDetails?.ProductGeneration,
    planType: PolicyDetails?.PlanType,
    ...PolicyDetails?.PolicyCover
  };

  const goToClaimsPage = () => {
    navigate(CSPUrlsMap.myClaims.url);
    dispatch(setFullPolicyNumber(FullPolicyNumber));
  };

  const whatCoveredPrintRef = useRef();

  const [expandAccordions, setExpandAccordions] = useState();

  const pageStyle = `@page {
      size: auto;
      margin: 10mm;
    }`;

  const handlePrint = useReactToPrint({
    onBeforePrint: () => {
      return new Promise((resolve) => {
        setExpandAccordions(true);
        setTimeout(resolve, 300);
      });
    },
    contentRef: whatCoveredPrintRef,
    onAfterPrint: () => {
      setExpandAccordions(false);
    },
    pageStyle
  });
  return (
    <div className="petPolicyLinksBar">
      <a
        className="linkBarButtons"
        rel="noreferrer"
        href={`${CSPUrlsMap.myDocuments.url}?policyId=${FullPolicyNumber}`}
      >
        <span className="labelText">Policy documents</span>
        <Icon icon="arrow-right2" />
      </a>

      <button
        type="button"
        className="linkBarButtons"
        onClick={goToClaimsPage}
      >
        <span className="labelText">Claims</span>
        <Icon icon="arrow-right2" />
      </button>

      {isWhatsCoveredEnabled && (
        <button
          className="linkBarButtons"
          type="button"
          onClick={showWhatsCovered}
        >
          <span className="labelText">What&rsquo;s covered</span>
          <Icon icon="arrow-right2" />
        </button>
      )}
      {isPayNowEnabled && (
        <a
          className="linkBarButtons"
          rel="noreferrer"
          href={`${CSPUrlsMap.premPayHistory.url}?policyId=${legacyPolicyNumberHandler(FullPolicyNumber)}`}
        >
          <span className="labelText">Premiums &amp; payments</span>
          <Icon icon="arrow-right2" />
        </a>
      )}

      <NewClaimButton
        customCss="newClaimButtonPolicyLink"
        fullPolicyNumber={FullPolicyNumber}
      />
      {isOpen && (
        <WhatsCoveredPopup
          isOpen
          onClose={() => setIsOpen(false)}
          dynamicValue={displayTags}
          cmsTags={cmsTags}
          dropdownField={PolicyDetails?.PolicyCover}
          planType={PolicyDetails?.PlanType}
          ref={whatCoveredPrintRef}
          onHandlePrint={handlePrint}
          expandAllAccordion={expandAccordions}
        />
      )}
    </div>
  );
};

PetPolicyLinksBar.propTypes = {
  petDetail: PropTypes.shape(PetDetailsPropTypes)
};
